// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ContactosRouteImport } from './routes/contactos'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PoliticaDeCookiesRouteImport } from './routes/politica-de-cookies'
import { Route as PoliticaDePrivacidadeRouteImport } from './routes/politica-de-privacidade'
import { Route as QuemSomosRouteImport } from './routes/quem-somos'
import { Route as TermosECondicoesRouteImport } from './routes/termos-e-condicoes'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as VenderAMinhaCasaRouteImport } from './routes/vender-a-minha-casa'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ContactosRoute = ContactosRouteImport.update({
            id: '/contactos',path: '/contactos',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const PoliticaDeCookiesRoute = PoliticaDeCookiesRouteImport.update({
            id: '/politica-de-cookies',path: '/politica-de-cookies',getParentRoute: () => rootRouteImport
          })
const PoliticaDePrivacidadeRoute = PoliticaDePrivacidadeRouteImport.update({
            id: '/politica-de-privacidade',path: '/politica-de-privacidade',getParentRoute: () => rootRouteImport
          })
const QuemSomosRoute = QuemSomosRouteImport.update({
            id: '/quem-somos',path: '/quem-somos',getParentRoute: () => rootRouteImport
          })
const TermosECondicoesRoute = TermosECondicoesRouteImport.update({
            id: '/termos-e-condicoes',path: '/termos-e-condicoes',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const VenderAMinhaCasaRoute = VenderAMinhaCasaRouteImport.update({
            id: '/vender-a-minha-casa',path: '/vender-a-minha-casa',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,ContactosRoute: ContactosRoute,LoginRoute: LoginRoute,PoliticaDeCookiesRoute: PoliticaDeCookiesRoute,PoliticaDePrivacidadeRoute: PoliticaDePrivacidadeRoute,QuemSomosRoute: QuemSomosRoute,TermosECondicoesRoute: TermosECondicoesRoute,UnsubscribeRoute: UnsubscribeRoute,VenderAMinhaCasaRoute: VenderAMinhaCasaRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)